import { Image } from '@vgn-medien-holding/vgn-fe-components';
import { PropsWithClassProps } from '@vgn-medien-holding/vgn-fe-components';
import { twMerge } from 'tailwind-merge';
import { FallbackCard } from '@components/atoms/FallbackCard/FallbackCard';
import { SubscriptionPageBox } from '@src/lib/graphql/generated';

export interface AboBoxesProp extends PropsWithClassProps {
  boxes: SubscriptionPageBox[];
}

export const AboBoxes = ({ boxes, classProps }: AboBoxesProp) => {
  if (!boxes) return null;

  return (
    <div className={twMerge('abo-card-gradient rounded-2xl border border-gray-650/60', classProps?.root)}>
      {boxes.map(
        (box, index) =>
          !!box && (
            <div
              className={twMerge(
                'flex flex-wrap gap-6 rounded-2xl p-8 pb-10 shadow-card-base md:flex-nowrap lg:gap-12 lg:p-12',
                index !== 0 && 'border-t border-gray-650/60',
                index % 2 !== 0 && 'flex-row-reverse',
              )}
              key={index}
            >
              <div className="relative h-40 w-full md:h-auto md:w-1/2">
                {box.image?.url ? (
                  <Image
                    classProps={{ root: 'rounded-2xl' }}
                    src={box.image.url}
                    copyright={box.image?.copyright_text}
                    alt={box.image?.alt || ''}
                    fill
                    imageMode="cover"
                  />
                ) : (
                  <FallbackCard />
                )}
              </div>
              <div className="w-full md:w-1/2">
                <div className="heading-4 mb-3 hyphens-auto text-white md:hyphens-manual">{box.headline}</div>
                <div className="text-base text-gray-400" dangerouslySetInnerHTML={{ __html: box.text }} />
              </div>
            </div>
          ),
      )}
    </div>
  );
};
